export default __webpack_public_path__ + "static/media/sleet.9bde30de.svg";